import { Box, Typography } from "@mui/material";
import { AlertModalCheckIcon } from "../../../../assets";
import { BaseAlertModal } from "../../../../components/modal/alert";
import { AppLayout } from "../../../../containers/layout/app";
import { EditGroupWrapper } from "./styled";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AppContext } from "../../../../context/appContext";
import { OnboardGroupAccountFormFieldsType } from "../../../../types/container.type";
import { UpdateGroup } from "../../../../containers/form/updategroup";
import Cookies from "universal-cookie";
import { updateGroupService } from "../../../../utils/api/customerservice/grouplist/updateGroup";

export const EditGroup = () => {
	const cookies = new Cookies();
	const TOKEN = cookies.getAll().TOKEN;

	const navigate = useNavigate();
	const { id = "" } = useParams();
	const { setActiveNavItem } = useContext(AppContext);

	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
	const [formDetails, setFormDetails] =
		useState<OnboardGroupAccountFormFieldsType>({
			accountType: " ",
			branch: "",
			name: "",
			registrationType: " ",
			savingsProduct: " ",
			accountManager: " ",
			meetingDay: "",
			meetingTime: "",
			meetingFrequency: " ",
			meetingLocation: "",
			email: "",
			primaryContactName: " ",
			primaryContactPhone: "",
			status: " ",
			mandate: "",
			members: [],
		});

	useEffect(() => {
		setActiveNavItem("Customer Service");
	}, [setActiveNavItem]);

	const handleAlertModalPersist = () => {
		return setIsAlertModalOpen(true);
	};

	const handleAlertModalCallToActionClick = () => {
		setIsAlertModalOpen(false);
		return navigate(-1);
	};

	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setError(null);
		setIsLoading(true);
		try {
			const response = await updateGroupService(TOKEN, id, formDetails);
			if (response.status === "success") {
				setIsLoading(false);
				setIsAlertModalOpen(true);
			} else {
				setIsLoading(false);
				setError(
					"Failed to update group information. Please check credentials and try again."
				);
			}
		} catch (error: any) {
			setIsLoading(false);
			setError(`Group update failed. ${error.message}`);
			console.error("Group update failed:", error);
		}
	};

	return (
		<AppLayout pageId={"Group-List"} pageTitle={"Edit Group"}>
			<EditGroupWrapper>
				{/* alert modal below */}
				<BaseAlertModal
					open={isAlertModalOpen}
					icon={<AlertModalCheckIcon />}
					title="Group Successfully Updated"
					message="Your information has been successfully added to the system."
					callToAction="Back to Group List"
					handleClose={handleAlertModalPersist}
					handleCallToAction={handleAlertModalCallToActionClick}
				/>
				{/* alert modal above */}
				<Box>
					<Typography
						variant="h3"
						fontFamily={"Poppins"}
						fontWeight={700}
						fontSize={20}
						lineHeight={"normal"}
						color="var(--dark-color)"
					>
						Edit Group Information
					</Typography>
				</Box>
				<UpdateGroup
					error={error}
					isLoading={isLoading}
					handleSubmit={handleSubmit}
					formDetails={formDetails}
					setFormDetails={setFormDetails}
					groupId={id}
				/>
			</EditGroupWrapper>
		</AppLayout>
	);
};
